export const validateName = (name: string) => {
	const nameTrim = name?.trim() || '';
	return nameTrim.length >= 2 && nameTrim.length <= 64;
};

export const validateStreet = (name: string) => {
	const namePattern = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9\s.,#\-()|]+$/;
	return name?.trim() !== '' && namePattern.test(name);
};

export const validatePhoneNumber = (_phone: string) => {
	const phonePattern = /^\d{10,15}$/;
	const phone = _phone
		.trim()
		.replaceAll(' ', '')
		.replaceAll('-', '')
		.replaceAll('(', '')
		.replaceAll(')', '')
		.replaceAll('+', '');
	return phone !== '' && phonePattern.test(phone);
};

export const validateEmail = (email: string) => {
	const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return email?.trim() !== '' && emailPattern.test(email);
};

export const validateZipCode = (zipCode: string) => {
	const zipCodePattern = /^[0-9]{1,6}$/;
	return zipCode?.trim() !== '' && zipCodePattern.test(zipCode);
};

export const validateXaddrExt = (xaddrExt: string) => {
	const xaddrExtPattern = /^[0-9a-zA-Z]{1,10}$/;
	return xaddrExt?.trim() !== '' && xaddrExtPattern.test(xaddrExt);
};

export const validateXaddrInt = (xaddrInt: string) => {
	const xaddrIntPattern = /^[0-9a-zA-Z]{1,10}$/;
	return xaddrInt?.trim() !== '' && xaddrIntPattern.test(xaddrInt);
};

export const validateAddressLine2 = (addressLine2: string) => {
	const addressLine2Trim = addressLine2?.trim() || '';
	return addressLine2Trim.length >= 1 && addressLine2Trim.length <= 72;
};

export const validateCity = (city: string) => {
	const cityTrim = city?.trim() || '';
	return cityTrim.length >= 2 && cityTrim.length <= 64;
};

export const validateState = (state: string) => {
	const stateTrim = state?.trim() || '';
	return stateTrim.length >= 2 && stateTrim.length <= 64;
};
